/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.1
 */
import { SagaIterator } from 'redux-saga';
import { call, delay, put, race, select, take } from 'redux-saga/effects';

import appRequest from '../app/appRequest';
import { fetchFailure, fetchSuccess, stopPolling } from './pollingActions';
import { START_POLLING, STOP_POLLING } from './pollingConstants';
import { makeSelectPollingRequesParams } from './pollingSelectors';

export function* pollingSaga(): SagaIterator {
    const { path, method, body, headers, duration } = yield select(makeSelectPollingRequesParams());

    const defauiltOptions = {
        body,
        credentials: 'include',
        headers: headers,
        method,
        mode: 'cors',
    };

    while (true) {
        try {
            const response = yield call(appRequest, path, defauiltOptions);
            yield put(fetchSuccess(response));
            yield delay(duration);
            if (!response.processed) {
                yield put(stopPolling());
            }
        } catch (e: any) {
            yield put(fetchFailure(e));
            yield put(stopPolling());
        }
    }
}

export function* watchPollSaga() {
    while (true) {
        yield take(START_POLLING);
        yield race([call(pollingSaga), take(STOP_POLLING)]);
    }
}
